import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="artist-type"
// Manages visibility driven by the Band / Soloist radio toggle:
//   - mixedGender: the "Mixed" gender option (only relevant for groups)
// Note: member count is now always shown (soloists enter 1).
export default class extends Controller {
  static targets = ["mixedGender"]

  connect() {
    this.toggle()
  }

  toggle() {
    const bandRadio = this.element.querySelector('input[type="radio"][value="band"]')
    const isBand = bandRadio?.checked ?? false

    // ── Mixed gender option ──────────────────────────────────────────
    this.mixedGenderTargets.forEach(el => {
      el.hidden = !isBand

      // If switching away from band while Mixed is selected, clear it
      if (!isBand) {
        const radio = el.querySelector('input[type="radio"]')
        if (radio?.checked) radio.checked = false
      }
    })
  }
}
